<template>
    <div class="row hero-section__paddder flex__row sd--bg">
        <div class="sd--text sd--text__padder">
            <img src="/images/stream-dreams/hero/sd-copy-img.png" alt="Logo" class="img-response">
        </div>
        <div class="sd--build">
            <img src="/images/stream-dreams/hero/mini-hero-bundle.png" alt="Build" class="img-response">
        </div>
    </div>
</template>

<script>
export default {
    name: "MiniHero"
}
</script>

<style lang="scss" scoped>
    .img-response {
        max-width: 100%;
    }
    // flexed content
    .flex__row {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: center;
    }

    .hero-section {
        &__padder {
            padding: 78px 15px 64px;
        }
    }

    .sd {
        &--bg {
            background-image: url("/images/stream-dreams/backgrounds/sd-bg-desktop.png");
            background-size: cover;
            background-position-y: -100px;
        }
        &--text {
            &__padder {
                padding: 58px 0 43px
            }

            img {
                width: 561px;
            }
        }
        &--build {
            align-self: flex-start;
        }
    }
    @media screen and (max-width: 1200px) and (min-width: 320px) {
        .sd {
            &--text, &--build {
                flex: 0 1 auto;
                width: 35%;
            }
            &--text {
                &__padder {
                    padding: 35px 0;
                }
            }
        }
    }
    @media screen and (max-width: 990px) and (min-width: 320px) {
        .flex__row {
            justify-content: center;
        }

        .hero-section {
            &__sd-padder {
                padding: 64px 15px;
            }
        }

        .sd {
            &--bg {
                background-image: url("/images/stream-dreams/backgrounds/sd-bg-mobile.png");
                background-size: cover;
                background-position-y: 0;
            }
            &--text {
                width: 100%;
                text-align: center;

                &__padder {
                    padding: 35px 15px;
                }

                img {
                    width: 91.1%;
                }
            }
            &--build {
                display: none;
            }
        }
    }
</style>
